import React, { useState, useEffect, useRef, useMemo } from 'react'
import { setLoading, setSnackInfo } from '../../redux/actions/appAction'
import { connect,useSelector } from 'react-redux'
import { useParams ,useHistory} from "react-router-dom";
import HttpService from '../../services/httpService'
import moment from 'moment'

const GLOBAL_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@300;400;500;600&display=swap');
.dp-scroll::-webkit-scrollbar{width:6px;height:6px}
.dp-scroll::-webkit-scrollbar-track{background:transparent}
.dp-scroll::-webkit-scrollbar-thumb{background:#C7CBD4;border-radius:99px}
.dp-card{transition:box-shadow .2s,transform .2s}
.dp-card:hover{box-shadow:0 8px 28px rgba(27,42,74,.13)!important;transform:translateY(-2px)}
.dp-btn{transition:all .18s ease;cursor:pointer;border:none;outline:none}
.dp-btn:active{transform:scale(.97)}
.dp-input{transition:border-color .15s,box-shadow .15s}
.dp-input:focus{border-color:#1B2A4A!important;box-shadow:0 0 0 3px rgba(27,42,74,.12)!important;outline:none}
.dp-tab{transition:all .2s}
.dp-item-row:hover{background:#F1F5FF!important}
.dp-modal-enter{animation:dpFadeIn .22s ease}
@keyframes dpFadeIn{from{opacity:0;transform:scale(.97)}to{opacity:1;transform:scale(1)}}
.dp-badge{display:inline-block;padding:2px 10px;border-radius:99px;font-size:11px;font-weight:600;font-family:"DM Sans",sans-serif;letter-spacing:.3px}
`
let cssInjected = false
function injectCSS() {
    if (cssInjected || typeof document === 'undefined') return
    const s = document.createElement('style')
    s.textContent = GLOBAL_CSS
    document.head.appendChild(s)
    cssInjected = true
}

const fmt = (n) => '₹' + Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 })
const TODAY = new Date().toISOString().split('T')[0]

// Total is simply rate × qty — no tax, no discount
const getTotal = (items) =>
    items.reduce(
        (s, ci) =>
            s +
            ((ci.item?.rate || ci.item?.price || ci.price || 0) *
                (ci.qty || ci.quantity || 0)),
        0
    )

// ─── Sub Components ───────────────────────────────────────────────────────────
const SearchBar = ({ value, onChange, placeholder, style }) => (
    <div style={{ position: 'relative', ...style }}>
        <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF', pointerEvents: 'none', fontSize: 16 }}>⌕</span>
        <input
            className="dp-input"
            value={value}
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder || 'Search…'}
            style={{ width: '100%', paddingLeft: 38, paddingRight: 14, paddingTop: 10, paddingBottom: 10, borderRadius: 10, border: '1.5px solid #E5E7EB', background: '#fff', fontSize: 14, fontFamily: '"DM Sans",sans-serif', color: '#1a1a1a', boxSizing: 'border-box' }}
        />
    </div>
)

const Badge = ({ status }) => {
    const isPaid = status === "paid"
    return (
        <span
            className="dp-badge"
            style={{
                background: isPaid ? "#D1FAE5" : "#FEF3C7",
                color: isPaid ? "#065F46" : "#92400E"
            }}
        >
            {isPaid ? "Paid" : "Unpaid"}
        </span>
    )
}

//  Color options for item  
const colorOptions = [
    { name: "White", code: "#FFFFFF" },
    { name: "Off White", code: "#F5F5F0" },
    { name: "Beige", code: "#E8DCC4" },
    { name: "Oak", code: "#C19A6B" },
    { name: "Teak", code: "#B5651D" },
    { name: "Walnut", code: "#5D4037" },
    { name: "Wenge", code: "#3B2F2F" },
    { name: "Grey", code: "#808080" },
    { name: "Black", code: "#000000" },
    { name: "Blue", code: "#2563EB" }
];


const FurnitureOne = (props) => {
    const history = useHistory();
    const {userDetails} = useSelector(state => state.user)
    const isAGMDGM =  userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales")) || userDetails?.roles?.some((role) => role?.name?.includes("AGM Sales")) ||
    userDetails?.roles?.some((role) => role?.name?.includes("DGM Design")) || userDetails?.roles?.some((role) => role?.name?.includes("AGM Design"))
    // console.log("userDetails in furniture one ", userDetails)
    // console.log("userDetails._id in furniture one ", userDetails._id)
    useEffect(() => { injectCSS() }, [])

    const dialogOverlayStyle = {
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(15,20,40,.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        backdropFilter: "blur(4px)"
    }

    const dialogBoxStyle = {
        background: "#fff",
        borderRadius: 18,
        width: 440,
        boxShadow: "0 24px 80px rgba(0,0,0,.22)",
        overflow: "hidden",
        fontFamily: '"DM Sans",sans-serif'
    }

    const dialogHeaderStyle = (bg = "#1B2A4A") => ({
        background: bg,
        padding: "18px 24px",
        display: "flex",
        alignItems: "center",
        gap: 12
    })

    const dialogBodyStyle = {
        padding: "22px 24px 24px"
    }

    const dialogActionsStyle = {
        display: "flex",
        justifyContent: "flex-end",
        gap: 10,
        marginTop: 22
    }

    const cancelBtnStyle = {
        padding: "9px 20px",
        borderRadius: 10,
        border: "1.5px solid #E5E7EB",
        background: "#fff",
        color: "#4B5563",
        fontWeight: 600,
        fontSize: 13,
        cursor: "pointer",
        fontFamily: '"DM Sans",sans-serif'
    }

    const confirmBtnStyle = (bg = "#1B2A4A", color = "#fff") => ({
        padding: "9px 22px",
        borderRadius: 10,
        border: "none",
        background: bg,
        color: color,
        fontWeight: 700,
        fontSize: 13,
        cursor: "pointer",
        fontFamily: '"DM Sans",sans-serif'
    })

    const dialogInputStyle = {
        width: "100%",
        padding: "10px 13px",
        border: "1.5px solid #E5E7EB",
        borderRadius: 10,
        fontSize: 14,
        fontFamily: '"DM Sans",sans-serif',
        color: "#1a1a1a",
        boxSizing: "border-box",
        marginTop: 8,
        outline: "none"
    }

    const labelStyle = {
        fontSize: 11,
        fontWeight: 700,
        color: "#6B7280",
        display: "block",
        marginBottom: 4
    }

    // ── state ──
    const [activeTab, setActiveTab] = useState('quotations')
    const [view, setView] = useState('list')
    const [quotations, setQuotations] = useState([])
    const [editingId, setEditingId] = useState(null)
    const [cartItems, setCartItems] = useState([])
    const [itemSearch, setItemSearch] = useState('')
    const [quoteSearch, setQuoteSearch] = useState('')
    const [ITEMS_CATALOG, setItemsCatalog] = useState([])
    const [page, setPage] = useState(1)
    const [itemPage, setItemPage] = useState(1)
    const [showRelogin, setShowRelogin] = useState(false)
    const [projectDetails, setProjectDetails] = useState(null)
    const [version, setVersion] = useState(null)

    const PER_PAGE = 25
    const queryParams = new URLSearchParams(window.location.search);
    const leadId = queryParams.get('leadId');
    // console.log('Lead ID from URL:', leadId)

    const [selectedQuote, setSelectedQuote] = useState(null)
    const [emailDialog, setEmailDialog] = useState(false)
    const [whatsAppDialog, setWhatsAppDialog] = useState(false)
    const [paidDialog, setPaidDialog] = useState(false)
    const [finalizeDialog, setFinalizeDialog] = useState(false)

    const [emailInput, setEmailInput] = useState("")
    const [whatsInput, setWhatsInput] = useState("")

    const [paidRemarks, setPaidRemarks] = useState("")
    const [paidFiles, setPaidFiles] = useState([])
    const [stockWarningDialog, setStockWarningDialog] = useState(false)
    const [pendingStockItem, setPendingStockItem] = useState(null)
    const [discountPercent, setDiscountPercent] = useState(0)
    // const [iscreateDisabled,setIscreateDisabled] = useState(true)

    const [customer, setCustomer] = useState({
        id: "",
        name: "",
        email: "",
        phone: ""
    })
    const [sameAsShipping, setSameAsShipping] = useState(false)
    const [paidS3Links, setPaidS3Links] = useState([]);
    const [uploadingFiles, setUploadingFiles] = useState(false);
    const isDisabled = !paidRemarks || paidFiles.length === 0 || uploadingFiles || paidS3Links.length === 0;

    useEffect(() => {
        fetchZohoItems()
        getcustomerDetails()
    }, [])
    useEffect(() => {
        setItemPage(1)
    }, [itemSearch])

    useEffect(() => {
        if (leadId) loadQuotations()
    }, [leadId])

    useEffect(() => {
        if (projectDetails?.uniqueLeadNumber) {
            setVersion(`${projectDetails.uniqueLeadNumber}.1`)
        }
    }, [projectDetails])

    // 
    const updateItemColor = (itemId, color) => {
        setCartItems(prev =>
            prev.map(ci =>
                ci.item.item_id === itemId
                    ? { ...ci, selectedColor: color }
                    : ci
            )
        );
    };

    const getcustomerDetails = async () => {
        props.setLoading(true);
        try {
            const response = await HttpService.getProjectLeadDetailsFurnitureOne(leadId);
            // console.log('Customer Details API response:', response.data.data);
            props.setLoading(false);
            setProjectDetails(response.data.data);

            return response.data.data;
        } catch (error) {
            console.error('API Error:', error);
            props.setLoading(false);
            props.setSnackInfo(error?.response?.data ?? "Unable to fetch data", "error");
            return error;
        }
    };
    // const navigateToItemDetail = (item) => {
    //     props.history.push(
    //         `/furniture-one-item-details?itemId=${item.item_id}`,
    //         { item, leadId }          
    //     )
    // }
    const navigateToItemDetail = (item) => {
        const url = `/furniture-one-item-details?itemId=${item.item_id}`;

        window.open(url, "_blank");
    };
    const navigateToApprovalPage = () =>{
        const url = `/furniture-one-approvals-section`;
        window.open(url, "_blank");
    }
    // console.log("projectDetails here ", projectDetails?.experienceCenterId)


    const loadQuotations = async () => {
        try {
            // console.log('Loading quotations for leadId:', leadId);
            props.setLoading(true);
            const res = await HttpService.getQuotationFurnitureOne(leadId);
            // console.log('Quotations API response:', res.data);
            setQuotations(res.data.data || []);
            props.setLoading(false);
        } catch (err) {
            console.error("loadQuotations error", err);
            props.setLoading(false);
        } finally {
            props.setLoading(false);
        }
    };

    const fetchZohoItems = async () => {
        try {
            props.setLoading(true)
            const res =  await HttpService.furnitureOneZohoItems()
            console.log("res is ", res)

            // console.log('Zoho API response status:', res.status)
            if (res.status === 401) {
                setShowRelogin(true)
                return
            }
            const resData = res?.data
            if (resData?.items) {
                const mapped = resData.items.map((item, index) => ({
                    item_id: item.item_id,
                    name: item.name?.replace(/"/g, ""),
                    group_name: item.category_name || "General",
                    description: item.description || item.dimensions_with_unit || "",
                    rate: item.rate || 0,
                    unit: item.unit || "pc",
                    tax_percentage: item?.item_tax_preferences?.[0]?.tax_percentage || 18,
                    sku: item.sku || item.item_id,
                    stock: item.available_stock ?? 0,
                    label_rate: item.label_rate || 0,
                    img: item.image_url_erp || "NA",
                    item_desc: item.item_description || "NA",
                    item_finish: item.item_finish_details || "NA",
                    // item_color: item.item_color_specification || "NA",
                    item_material: item.item_material_specification || "NA",
                    item_dimensions: item.item_dimensions_specification || "NA",
                    item_whats_included: item.item_whats_included || "NA"

                }))
                setItemsCatalog(mapped)
            }
        } catch (err) {
            if (err.response?.status === 401 && err.response?.data?.code === 'NOT_AUTHENTICATED') {
                setShowRelogin(true);
            } else {
                props.setSnackInfo("Failed to load Zoho items", "warning")
            }
            
        } finally {
            props.setLoading(false)
        }
    }
     // handle login zoho pos api..
    const handleRelogin = () => {
        // const url = "http://localhost:5003/api/furnitureOne/zoho/login"
        // const url = "http://65.0.23.165:5003/api/furnitureOne/zoho/login"
         const url = "https://quotationerp.decorpot.com/api/furnitureOne/zoho/login"
        window.open(url, "_blank")
    }
    // save quotation function ...
    const saveQuotation = async (finalized, finalDiscount) => {
    const quote = selectedQuote || {}
    const quoteVersion = quote?.version || version
    const quoteLeadId = quote?.leadId || leadId

    if (!quoteVersion) {
        props.setSnackInfo("Version not ready yet", "error")
        return
    }

    try {
        const formData = new FormData()
        formData.append("version", quoteVersion)
        formData.append("leadId", quoteLeadId)
        formData.append("customerId", projectDetails?.customerId?._id || "")
        formData.append("finalized", finalized)
        if (finalized) formData.append("discountPercent", finalDiscount)
        // console.log("Final Discount being sent:", finalDiscount)

        const itemsPayload = cartItems.map(ci => ({
            item_id: ci.item.item_id,
            name: ci.item.name,
            description: ci.item.description || "",
            price: ci.item.rate,
            label_rate: ci.item.label_rate || 0,
            category: ci.item.group_name,
            quantity: ci.qty,
            // Resolve color: if "Other", use the typed value; else use swatch name
            color: ci.selectedColor?.name === 'Other'
                ? (ci.customColor || 'Other')
                : (ci.selectedColor?.name || 'White'),
            img: ci.item.img || "",
            item_dimensions: ci.item.item_dimensions || 'NA',
            item_material: ci.item.item_material || 'NA',
        }))
        // console.log("Items payload:", itemsPayload) 
        formData.append("items", JSON.stringify(itemsPayload))

        props.setLoading(true)
        const response = await HttpService.saveQuotationFurnitureOne(formData)
        // console.log("Save Quotation response:", response)

        if (finalized) props.setSnackInfo("Quotation finalized!", "success")
        else props.setSnackInfo("Quotation saved!", "success")
        if(!finalized){
        loadQuotations()
        setView('list')
        }
        return response.data?.data

    } catch (err) {
        props.setSnackInfo("Failed to save quotation", "error")
    } finally {
        props.setLoading(false)
    }
}

// this is to mark as paid  and create invoice with customer in zoho if customer not present ..
    const saveQuotationAsPaid = async (
        finalized = true,
        paid = true,
        remarks = "",
        fileLinks = []
    ) => {
        const quote = selectedQuote || {}
        const quoteVersion = quote?.version || version
        const quoteLeadId = quote?.leadId || leadId
        const quotationId = quote?._id
        if (!quoteVersion) {
            props.setSnackInfo("Version not ready yet", "error")
            return
        }
        if (paid && !finalized) {
            props.setSnackInfo("Quotation must be finalized before marking as paid", "error")
            return
        }
        try {
            const formData = new FormData()
            formData.append("version", quoteVersion)
            formData.append("leadId", quoteLeadId)
            formData.append("quotationId", quotationId)
            formData.append("customerId", projectDetails?.customerId?._id || "")
            formData.append("finalized", finalized)
            formData.append("paid", paid)
            formData.append("status", paid ? "paid" : "unpaid")
            formData.append("remarks", remarks)

            // files.forEach(f => formData.append("files", f))
            fileLinks.forEach(link => formData.append("fileLinks", link))
            props.setLoading(true)
            const res = await HttpService.markPaidAndCreateInvoice(formData)

            // Update customer state from combined response
            const zoho = res.data.customer
            setCustomer({
                id: zoho.contact_id,
                name: zoho.contact_name,
                email: zoho.email,
                phone: zoho.mobile
            })

            // props.setSnackInfo(
            //     res.data.alreadyExists
            //         ? "Customer already exists"
            //         : "Customer created successfully",
            //     "success"
            // )
            if (paid) props.setSnackInfo("Quotation marked as paid!", "success")
            else if (finalized) props.setSnackInfo("Quotation finalized!", "success")
            else props.setSnackInfo("Quotation saved!", "success")

            loadQuotations()
            setView('list')

        } catch (err) {
            props.setSnackInfo("Failed to save quotation", "error")
        } finally {
            props.setLoading(false)
        }
    }

    const openEmailDialog = (q) => {
        setSelectedQuote(q)
        setEmailInput(q?.customerId?.email || "")
        setEmailDialog(true)
    }
    const openWhatsAppDialog = (q) => {
        setSelectedQuote(q)
        setWhatsInput(q?.customerId?.contact_no || "")
        setWhatsAppDialog(true)
    }
    const openFinalizeDialog = (q) => {
        setSelectedQuote(q)
        setFinalizeDialog(true)
    }

// this function first saves the quotation and then confirm it ..
const confirmFinalize = async () => {
    const currentQuote = selectedQuote || quotations.find(q => q.version === version) || null

    if (currentQuote?.discountApprovalStatus?.status === "pending") {
        props.setSnackInfo("An approval is already pending. Cannot finalize.", "error")
        setFinalizeDialog(false)
        return
    }

    if (Number(discountPercent) > 5) {
        const approvalStatus = currentQuote?.discountApprovalStatus?.status
        if (approvalStatus !== "approved") {
            props.setSnackInfo("Discount above 5% requires approval first", "error")
            setFinalizeDialog(false)
            return
        }
    }

    setFinalizeDialog(false)

    try {
        props.setLoading(true)

        // ≤5%  → read from input (user typed it, no approval involved)
        // >5% approved → discount already in discountApprovalStatus.discountPercent,
        //                pass 0 from here — backend will NOT overwrite approved value
        const finalDiscount = currentQuote?.discountApprovalStatus?.status === "approved"
            ? 0   // backend skips write when approved, so value doesn't matter — pass 0
            : Number(discountPercent) || 0

        const savedResponse = await saveQuotation(true, finalDiscount)

        // savedResponse is now response.data?.data — the quotation document
        if (!savedResponse) {
            props.setSnackInfo("Failed to finalize quotation", "error")
            return
        }

        let pdfGenerated = false
        const customerPayload = {
            name: projectDetails?.customerId?.name || '',
            email: projectDetails?.customerId?.email || '',
            contact_no: projectDetails?.customerId?.contact_no || ''
        }

        try {
            const res = await HttpService.generateQuotationPDF({
                quotationId: savedResponse._id,
                quoteId: savedResponse.version,
                customer: customerPayload,
                cartItems: cartItems
            })
            if (res?.data?.s3Url) pdfGenerated = true
        } catch (err) {
            console.error('PDF generation failed silently:', err)
        }

        if (pdfGenerated) props.setSnackInfo("Quotation finalized & PDF saved!", "success")
        else props.setSnackInfo("Quotation finalized, but PDF generation failed. You can retry.", "warning")

        await loadQuotations()
        setView('list')

    } catch (err) {
        console.error('confirmFinalize error:', err)
        props.setSnackInfo("Failed to finalize quotation", "error")
    } finally {
        props.setLoading(false)
    }
}
// send discount approval ., goes to dgm./agm of the user
    const sendDiscountApproval = async (discountPercent) => {
    try {
        setFinalizeDialog(false)
         const currentQuote = selectedQuote || quotations.find(q => q.version === version) || null
        const quote = selectedQuote || {}
        const quoteVersion = quote?.version || version
        const quoteLeadId = quote?.leadId || leadId
        const userDepartment = userDetails?.departmentId || ""
        const experienceCenterId = projectDetails?.experienceCenterId || ""
        props.setLoading(true)
        const response = await HttpService.sendDiscountApprovalForFurnitureOne({
            quoteLeadId,
            quoteVersion,
            discountPercent,
            userDepartment,
            experienceCenterId
        })
        if (response?.status === 200 || response?.data?.success) {
            props.setSnackInfo(response?.data?.message || "Discount approval sent!", "success")
            await loadQuotations()   // ← reload so pending status is fresh in state
        }
    } catch (error) {
        props.setSnackInfo(error?.response?.data?.message || "Failed to send discount approval", "error")
    } finally {
        props.setLoading(false)
    }
}
    // saving pdf seperately if pdf generation fails..
    const handleGeneratePDF = async (q) => {
    try {
        props.setLoading(true)
        const customerPayload = {
            name:  projectDetails?.customerId?.name || '',
            email:  projectDetails?.customerId?.email || '',
            contact_no:  projectDetails?.customerId?.contact_no || ''
        }

        const res = await HttpService.generateQuotationPDF({
            quotationId: q._id,
            quoteId: q.version,
            customer: customerPayload,
            cartItems: q.items.map(i => ({
                item: { 
                    item_id: i.item_id, 
                    name: i.name, 
                    rate: i.price, 
                    label_rate: i.label_rate || 0,
                    group_name: i.category,
                    description: i.description ,
                    img: i.img || "",
                    item_dimensions: i.dimensions || 'NA',
                    item_material: i.material || 'NA',
                    color: i.color || 'NA',
                    
                },
                qty: i.quantity
            }))
        })

        if (res?.data?.s3Url) {
            props.setSnackInfo("PDF generated & saved!", "success")
            loadQuotations() // refresh to show updated s3Url
        }
    } catch (err) {
        console.error('PDF generation error:', err)
        props.setSnackInfo("Failed to generate PDF", "error")
    } finally {
        props.setLoading(false)
    }
}

    const openPaidDialog = (q) => {
        setSelectedQuote(q)
        setPaidRemarks("")
        setPaidFiles([])
        setPaidDialog(true)
    }
    const confirmPaid = () => {
        if (!paidS3Links.length) {
            props.setSnackInfo("Please attach proof (mandatory)", "error");
            return;
        }
        saveQuotationAsPaid(true, true, paidRemarks, paidS3Links)
        setPaidDialog(false)
    }
  // close paid dialog and reset files and links
    const closePaidDialog = () => {
    setPaidDialog(false);
    setPaidFiles([]);
    setPaidS3Links([]);
};

    const confirmEmail = async () => {
        setEmailDialog(false)
        try {
            props.setLoading(true)
            await HttpService.sendQuotationMailOrWhatsappForFurnitureOne({
                contactType: "email",
                email: emailInput,
                quotation: selectedQuote._id
            })
            props.setSnackInfo("Quotation sent via email!", "success")
        } catch {
            props.setSnackInfo("Failed to send email", "error")
        } finally {
            props.setLoading(false)
        }
    }

    const confirmWhatsApp = async () => {
        setWhatsAppDialog(false)
        try {
            props.setLoading(true)
            await HttpService.sendQuotationMailOrWhatsappForFurnitureOne({
                contactType: "whatsapp",
                whatsappNumber: whatsInput,
                quotation: selectedQuote._id
            })
            props.setSnackInfo("Quotation sent via WhatsApp!", "success")
        } catch {
            props.setSnackInfo("Failed to send WhatsApp message", "error")
        } finally {
            props.setLoading(false)
        }
    }
    // upload  payment files to s3 onchange 
    const handlePaidFileChange = async (e) => {
    const selectedFiles = Array.from(e.target.files);
    if (!selectedFiles.length) return;

    setPaidFiles(selectedFiles); 
    setUploadingFiles(true);

    try {
        const s3Links = [];
        for (const file of selectedFiles) {
            const formData = new FormData();
            formData.append("file", file);
            const response = await HttpService.uploadFile(formData);
            const s3Link = response.data.s3Link || response.data;
            if (s3Link) s3Links.push(s3Link);
        }
        setPaidS3Links(s3Links);
    } catch (error) {
        props.setSnackInfo(error?.response?.data?.message || "File upload failed", "error");
        setPaidFiles([]);
        setPaidS3Links([]);
    } finally {
        setUploadingFiles(false);
    }
};

    // ── derived ──
    const filteredItems = useMemo(() =>
        ITEMS_CATALOG.filter(i =>
            i.name.toLowerCase().includes(itemSearch.toLowerCase()) ||
            i.group_name.toLowerCase().includes(itemSearch.toLowerCase()) ||
            i.sku.toLowerCase().includes(itemSearch.toLowerCase())
        ), [ITEMS_CATALOG, itemSearch])

    const paginatedItems = useMemo(() => {
        const start = (itemPage - 1) * PER_PAGE
        return filteredItems.slice(start, start + PER_PAGE)
    }, [filteredItems, itemPage])

    const totalPages = Math.ceil(filteredItems.length / PER_PAGE)

    const filteredQuotes = useMemo(() =>
        quotations.filter(q =>
            q.customerId?.name.toLowerCase().includes(quoteSearch.toLowerCase()) ||
            q.id.toLowerCase().includes(quoteSearch.toLowerCase())
        ), [quotations, quoteSearch])
    // console.log('Filtered Quotes:', filteredQuotes)

    // Cart total — rate is the final rate, no tax or discount applied
    const cartTotal = useMemo(() => getTotal(cartItems), [cartItems])

    // ── handlers ──
    const openNew = () => {
        const existingNumbers = quotations.map(q => {
            const parts = q.version?.split('.')
            return parseInt(parts?.[parts.length - 1]) || 0
        })
        const next = existingNumbers.length > 0
            ? Math.max(...existingNumbers) + 1
            : 1
        setSelectedQuote(null)
        setVersion(`${projectDetails?.uniqueLeadNumber}.${next}`)
        setCartItems([])
        setCustomer({ name: '', email: '', phone: '' })
        setItemSearch('')
        setView('builder')
    }

 const openEdit = (q) => {
    setSelectedQuote(q)
    setVersion(q.version)
    setCartItems(
        q.items.map(ci => ({
            item: {
                item_id: ci.item_id,
                name: ci.name,
                description: ci.description,
                rate: ci.price,
                label_rate: ci.label_rate || 0,
                group_name: ci.category,
                tax_percentage: 18,
                img: ci.img || "",
                color: ci.color || 'White',
                item_dimensions: ci.dimensions || 'NA',   // ← was ci.item_dimensions
                item_material: ci.material || 'NA',       // ← was ci.item_material
            },
            qty: ci.quantity,
            selectedColor: ci.color
                ? { name: ci.color, code: colorOptions.find(c => c.name === ci.color)?.code || '#fff' }
                : colorOptions[0],
            customColor: ci.color && !colorOptions.find(c => c.name === ci.color) ? ci.color : ''
        }))
    )
    setView('builder')
}

    const addItem = (item) => {
        if (item.stock <= 0) {
            setPendingStockItem(item)
            setStockWarningDialog(true)
            return
        }
        setCartItems(prev => {
            const ex = prev.find(ci => ci.item.item_id === item.item_id)
            if (ex) return prev.map(ci => ci.item.item_id === item.item_id ? { ...ci, qty: ci.qty + 1 } : ci)
            // return [...prev, { item, qty: 1 ,selectedColor: colorOptions[0]}]
        return [...prev, { item, qty: 1, selectedColor: colorOptions[0], customColor: '' }]
        })
    }
    const confirmStockWarning = () => {
        if (!pendingStockItem) return
        setCartItems(prev => {
            const ex = prev.find(ci => ci.item.item_id === pendingStockItem.item_id)
            if (ex) return prev.map(ci => ci.item.item_id === pendingStockItem.item_id ? { ...ci, qty: ci.qty + 1 } : ci)
            // return [...prev, { item: pendingStockItem, qty: 1 ,selectedColor: colorOptions[0]}]
        return [...prev, { item : pendingStockItem, qty: 1, selectedColor: colorOptions[0], customColor: '' }]
        })
        setStockWarningDialog(false)
        setPendingStockItem(null)
    }

    const changeQty = (itemId, delta) => {
        setCartItems(prev => prev.map(ci => {
            if (ci.item.item_id !== itemId) return ci
            const nq = ci.qty + delta
            return nq < 1 ? null : { ...ci, qty: nq }
        }).filter(Boolean))
    }
    //  console.log("cartItems with after add  ", cartItems); 

    const removeFromCart = (itemId) => setCartItems(prev => prev.filter(ci => ci.item.item_id !== itemId))
    // ═══════════════════════════════════════════════════════════════════════════
    // RENDER: BUILDER VIEW
    // ═══════════════════════════════════════════════════════════════════════════

    if (view === 'builder') {
        const inCart = (id) => cartItems.find(ci => ci.item.item_id === id)
        return (
            <div style={{ minHeight: '100vh', background: '#F0F2F8', fontFamily: '"DM Sans",sans-serif' }}>
                {/* Header */}
                <div style={{ background: '#1B2A4A', padding: '0 32px', display: 'flex', alignItems: 'center', gap: 16, height: 62, boxShadow: '0 2px 12px rgba(0,0,0,.25)' }}>
                    <button className="dp-btn" onClick={() => setView('list')} style={{ background: 'rgba(255,255,255,.12)', color: '#fff', borderRadius: 8, padding: '6px 14px', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
                        ← Back
                    </button>
                    <span style={{ color: '#fff', fontFamily: '"Playfair Display",serif', fontSize: 20, fontWeight: 600, flex: 1 }}>
                        {editingId ? `Edit Quotation – ${editingId}` : 'New Quotation'}
                    </span>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 380px', gap: 20, padding: 24, maxWidth: 1400, margin: '0 auto', boxSizing: 'border-box' }}>

                    {/* LEFT: Items */}
                    <div>
                        <div>

                            {/* Customer Info */}
                            <div style={{
                                background: '#fff',
                                borderRadius: 14,
                                padding: 10,
                                marginBottom: 20,
                                boxShadow: '0 1px 6px rgba(0,0,0,.07)'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    marginBottom: 10
                                }}>
                                    <p style={{ margin: 0, fontWeight: 600, fontSize: 15, color: '#1B2A4A' }}>
                                        👤 Customer Details
                                    </p>
                                </div>

                                {projectDetails?.customerId?.name  && (
                                    <div style={{ background: '#F9FAFB', borderRadius: 10, padding: 12, border: '1px solid #E5E7EB' }}>
                                        <div style={{ fontWeight: 600 }}>
                                            👤 Name : {projectDetails?.customerId?.name  || "-"}
                                        </div>
                                        <div style={{ fontSize: 13, color: '#6B7280' }}>
                                            📞 Phone : {projectDetails?.customerId?.contact_no || "-"}
                                        </div>
                                        <div style={{ fontSize: 13, color: '#6B7280' }}>
                                            ✉️ Email : {projectDetails?.customerId?.email || "-"}
                                        </div>
                                        {/* <div style={{ fontSize: 13, color: '#6B7280' }}>
                                            🪪 Furniture One Id : {projectDetails?.furnitureOneCustomerId?.zohoContactId || "-"}
                                        </div> */}
                                    </div>
                                )}
                            </div>

                        </div>

                        {/* Items Panel */}
                        <div style={{ background: '#fff', borderRadius: 14, boxShadow: '0 1px 6px rgba(0,0,0,.07)', overflow: 'hidden' }}>
                            <div style={{ padding: '18px 20px', borderBottom: '1px solid #F1F3F9', display: 'flex', alignItems: 'center', gap: 14 }}>
                                <span style={{ fontWeight: 600, fontSize: 15, color: '#1B2A4A', flex: 1 }}>📦 Select Items</span>
                                <SearchBar value={itemSearch} onChange={setItemSearch} placeholder="Search items, category, SKU…" style={{ width: 280 }} />
                            </div>
                            <div className="dp-scroll" style={{ maxHeight: 'calc(100vh - 330px)', overflowY: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ background: '#F8F9FD' }}>
                                            {['Item', 'Category', 'SKU', 'Rate', 'Stock', ''].map(h => (
                                                <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#6B7280', letterSpacing: '.5px', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{h}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedItems.map(item => {
                                            const inC = inCart(item.item_id)
                                            return (
                                                <tr key={item.item_id} className="dp-item-row" style={{ borderBottom: '1px solid #F1F3F9', background: '#fff' }}>
                                                    <td style={{ padding: '12px 14px' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                                            <img src={item.img} alt="" style={{ width: 48, height: 36, borderRadius: 7, objectFit: 'cover', background: '#F1F3F9' }} />
                                                            <div>
                                                                <div style={{ fontWeight: 600, fontSize: 13, color: '#1a1a1a' }}>{item.name}</div>
                                                                <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 2, maxWidth: 220, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.description}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: '12px 14px', fontSize: 12, color: '#6B7280', whiteSpace: 'nowrap' }}>{item.group_name}</td>
                                                    <td style={{ padding: '12px 14px', fontSize: 12, color: '#9CA3AF', fontFamily: 'monospace' }}>{item.sku}</td>
                                                    <td style={{ padding: '12px 14px', whiteSpace: 'nowrap' }}>
                                                        {item.label_rate > item.rate && (
                                                            <span style={{ fontSize: 11, color: '#9CA3AF', textDecoration: 'line-through', display: 'block', lineHeight: 1.2 }}>
                                                             {fmt(item.label_rate)}
                                                            </span>
                                                        )}
                                                        <span style={{ fontSize: 13, fontWeight: 700, color: '#1B2A4A' }}>
                                                            {fmt(item.rate)}<span style={{ fontSize: 10, color: '#9CA3AF', fontWeight: 400 }}>/{item.unit}</span>
                                                        </span>
                                                    </td>
                                                    <td style={{ padding: '12px 14px', fontSize: 12, color: item.stock < 10 ? '#EF4444' : '#10B981', fontWeight: 500 }}>{item.stock > 100 ? '✓' : item.stock}</td>
                                                    <td style={{ padding: '12px 14px' }}>
                                                        {inC ? (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#EEF2FF', borderRadius: 8, padding: '4px 8px', width: 'fit-content' }}> <button className="dp-btn" onClick={() => changeQty(item.item_id, -1)} style={{ background: '#1B2A4A', color: '#fff', width: 24, height: 24, borderRadius: 6, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>− </button>
                                                                <span style={{ fontSize: 13, fontWeight: 700, color: '#1B2A4A', minWidth: 20, textAlign: 'center' }}>
                                                                    {inC.qty}
                                                                </span>
                                                                <button
                                                                    className="dp-btn"
                                                                    onClick={() => addItem(item)}
                                                                    style={{ background: '#1B2A4A', color: '#fff', width: 24, height: 24, borderRadius: 6, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }} >+ </button>
                                                            </div>
                                                        ) : (
                                                            <button
                                                                className="dp-btn"
                                                                onClick={() => addItem(item)}
                                                                style={{
                                                                    background: '#1B2A4A',
                                                                    color: '#fff',
                                                                    borderRadius: 8,
                                                                    padding: '6px 14px',
                                                                    fontSize: 12,
                                                                    fontWeight: 600
                                                                }}
                                                            >
                                                                + Add
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        {filteredItems.length === 0 && (
                                            <tr><td colSpan={6} style={{ padding: 40, textAlign: 'center', color: '#9CA3AF', fontSize: 14 }}>No items found</td></tr>
                                        )}
                                    </tbody>
                                    {totalPages > 1 && (
                                        <div style={{
                                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                            padding: '12px 16px', borderTop: '1px solid #F1F3F9', background: '#fff'
                                        }}>
                                            <span style={{ fontSize: 12, color: '#6B7280', marginRight: 2 }}>
                                                Showing  {(itemPage - 1) * PER_PAGE + 1} to {Math.min(itemPage * PER_PAGE, filteredItems.length)} of {filteredItems.length}
                                            </span>
                                            <div style={{ display: 'flex', gap: 10 }}>
                                                <button className="dp-btn" disabled={itemPage === 1} onClick={() => setItemPage(p => p - 1)}
                                                    style={{ padding: '6px 12px', borderRadius: 8, background: '#EEF2FF' }}>Prev</button>
                                                <span style={{ padding: '6px 12px', fontWeight: 600 }}>{itemPage} / {totalPages}</span>
                                                <button className="dp-btn" disabled={itemPage === totalPages} onClick={() => setItemPage(p => p + 1)}
                                                    style={{ padding: '6px 12px', borderRadius: 8, background: '#EEF2FF' }}>Next</button>
                                            </div>
                                        </div>
                                    )}
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT: Cart */}
                    <div>
                        <div style={{ background: '#fff', borderRadius: 14, boxShadow: '0 1px 6px rgba(0,0,0,.07)', position: 'sticky', top: 24 }}>
                            <div style={{ padding: '18px 20px', borderBottom: '1px solid #F1F3F9' }}>
                                <span style={{ fontWeight: 700, fontSize: 16, color: '#1B2A4A', fontFamily: '"Playfair Display",serif' }}>
                                    🛒 Cart {cartItems.length ? `(${cartItems.length})` : ''}
                                </span>
                            </div>
                            <div className="dp-scroll" style={{ maxHeight: 400, overflowY: 'auto' }}>
                                {cartItems.length === 0 ? (
                                    <div style={{ padding: 40, textAlign: 'center' }}>
                                        <div style={{ fontSize: 40, marginBottom: 12 }}>🛒</div>
                                        <p style={{ color: '#9CA3AF', fontSize: 14, margin: 0 }}>Add items from the list</p>
                                    </div>
                                ) : cartItems.map(ci => (
                                    <div key={ci.item.item_id} style={{ padding: '14px 18px', borderBottom: '1px solid #F8F9FC', display: 'flex', flexDirection: 'column', gap: 8 }}>

                                        <div style={{ display: 'flex', gap: 12 }}>

                                            {/* IMAGE */}
                                            <img
                                                src={ci.item.img || ci.item.image_url_erp}
                                                alt={ci.item.name}
                                                style={{
                                                    width: 62,
                                                    height: 62,
                                                    borderRadius: 10,
                                                    objectFit: 'cover',
                                                    border: '1px solid #E5E7EB',
                                                    flexShrink: 0,
                                                    background: '#F9FAFB'
                                                }}
                                            />

                                            {/* RIGHT SIDE */}
                                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>

                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', lineHeight: 1.3 }}>
                                                            {ci.item.name}
                                                        </div>

                                                        {/* <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 2 }}>
                                                            {ci.item.unit} · {fmt(ci.item.rate)}
                                                        </div> */}
                                                        <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 2 }}>
                                                            {ci.item.unit}
                                                            {ci.item.label_rate > ci.item.rate && (
                                                                <span style={{ textDecoration: 'line-through', marginLeft: 6, color: '#ff0000ff' ,fontWeight: 300}}>
                                                                    {fmt(ci.item.label_rate)}
                                                                </span>
                                                            )}
                                                            <span style={{ marginLeft: 4, color: '#6B7280', fontWeight: 600 }}>{fmt(ci.item.rate)}</span>
                                                        </div>
                                                    </div>

                                                    <button
                                                        className="dp-btn"
                                                        onClick={() => removeFromCart(ci.item.item_id)}
                                                        style={{
                                                            background: '#FEE2E2',
                                                            color: '#EF4444',
                                                            borderRadius: 6,
                                                            width: 26,
                                                            height: 26,
                                                            fontSize: 14,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            flexShrink: 0,
                                                            padding: 0
                                                        }}
                                                    >
                                                        ×
                                                    </button>
                                                </div>

                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    {/* COLOR PICKER */}
                                                    <div
                                                        style={{
                                                            marginTop: 10,
                                                            paddingTop: 10,
                                                            borderTop: '1px dashed #E5E7EB'
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                fontSize: 11,
                                                                fontWeight: 600,
                                                                color: '#6B7280',
                                                                marginBottom: 8
                                                            }}
                                                        >
                                                            Color:
                                                            <span
                                                                style={{
                                                                    marginLeft: 6,
                                                                    color: '#1B2A4A'
                                                                }}
                                                            >
                                                                {ci.selectedColor?.name || "White"}
                                                            </span>
                                                        </div>

                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexWrap: 'wrap',
                                                                gap: 8
                                                            }}
                                                        >
                                                            {colorOptions.map(color => (
                                                                <div
                                                                    key={color.name}
                                                                    title={color.name}
                                                                    onClick={() => updateItemColor(ci.item.item_id, color)}
                                                                    style={{
                                                                        width: 24, height: 24, borderRadius: '50%',
                                                                        background: color.code, cursor: 'pointer',
                                                                        transition: 'all .2s ease',
                                                                        border: ci.selectedColor?.name === color.name
                                                                            ? '3px solid #1B2A4A' : '1px solid #D1D5DB',
                                                                        boxShadow: ci.selectedColor?.name === color.name
                                                                            ? '0 0 0 2px rgba(27,42,74,.15)' : 'none'
                                                                    }}
                                                                />
                                                            ))}
                                                            <div
                                                                title="Other"
                                                                onClick={() => updateItemColor(ci.item.item_id, { name: 'Other', code: 'linear-gradient(135deg,#f00,#0f0,#00f)' })}
                                                                style={{
                                                                    width: 24, height: 24, borderRadius: '50%',
                                                                    background: 'linear-gradient(135deg,#f00,#0f0,#00f)',
                                                                    cursor: 'pointer', border: ci.selectedColor?.name === 'Other'
                                                                        ? '3px solid #1B2A4A' : '1px solid #D1D5DB',
                                                                    boxShadow: ci.selectedColor?.name === 'Other'
                                                                        ? '0 0 0 2px rgba(27,42,74,.15)' : 'none',
                                                                    flexShrink: 0
                                                                }}
                                                            />
                                                            {ci.selectedColor?.name === 'Other' && (
                                                                <input
                                                                    className="dp-input"
                                                                    placeholder="Type color…"
                                                                    value={ci.customColor || ''}
                                                                    onChange={e => setCartItems(prev =>
                                                                        prev.map(c => c.item.item_id === ci.item.item_id
                                                                            ? { ...c, customColor: e.target.value }
                                                                            : c
                                                                        )
                                                                    )}
                                                                    style={{
                                                                        marginTop: 8, width: '100%', padding: '6px 10px',
                                                                        borderRadius: 8, border: '1.5px solid #E5E7EB',
                                                                        fontSize: 12, fontFamily: '"DM Sans",sans-serif',
                                                                        color: '#1a1a1a', boxSizing: 'border-box', outline: 'none'
                                                                    }}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#F8F9FC', borderRadius: 8, padding: '4px 8px' }}>
                                                        <button
                                                            className="dp-btn"
                                                            onClick={() => changeQty(ci.item.item_id, -1)}
                                                            style={{
                                                                background: '#E5E7EB',
                                                                color: '#1a1a1a',
                                                                width: 22,
                                                                height: 22,
                                                                borderRadius: 5,
                                                                fontSize: 13,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                padding: 0
                                                            }}
                                                        >
                                                            −
                                                        </button>

                                                        <span style={{ fontSize: 13, fontWeight: 700, color: '#1B2A4A', minWidth: 22, textAlign: 'center' }}>
                                                            {ci.qty}
                                                        </span>

                                                        <button
                                                            className="dp-btn"
                                                            onClick={() => changeQty(ci.item.item_id, 1)}
                                                            style={{
                                                                background: '#1B2A4A',
                                                                color: '#fff',
                                                                width: 22,
                                                                height: 22,
                                                                borderRadius: 5,
                                                                fontSize: 13,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                padding: 0
                                                            }}
                                                        >
                                                            +
                                                        </button>
                                                    </div>

                                                    <span style={{ fontSize: 14, fontWeight: 700, color: '#1B2A4A' }}>
                                                        {fmt(ci.item.rate * ci.qty)}
                                                    </span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {cartItems.length > 0 && (
                                <div style={{ padding: '16px 18px', borderTop: '2px solid #F1F3F9' }}>
                                    {/* Single total row — rate is final, no tax or discount */}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', background: '#1B2A4A', borderRadius: 10, padding: '12px 14px', marginBottom: 14 }}>
                                        <span style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>Total</span>
                                        <span style={{ color: '#F59E0B', fontWeight: 700, fontSize: 17 }}>
                                            {fmt(cartTotal)}
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                        <button className="dp-btn" onClick={() => saveQuotation(false)}
                                            style={{ background: '#EEF2FF', color: '#1B2A4A', borderRadius: 10, padding: '10px', fontWeight: 600, fontSize: 13, width: '100%' }}>
                                            Save Draft
                                        </button>
                                        <button className="dp-btn" onClick={() => openFinalizeDialog()}
                                            style={{ background: '#EEF2FF', color: '#1B2A4A', borderRadius: 10, padding: '10px', fontWeight: 600, fontSize: 13, width: '100%' }}>
                                            Finalize Quotation
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {stockWarningDialog && (
                        <div style={dialogOverlayStyle}>
                            <div style={{ ...dialogBoxStyle, width: 600 }} className="dp-modal-enter">
                                <div style={dialogHeaderStyle("#92400E")}>
                                    <span style={{ fontSize: 22 }}>⚠️</span>
                                    <div>
                                        <div style={{ color: "#fff", fontFamily: '"Playfair Display",serif', fontSize: 17, fontWeight: 600 }}>
                                            Stock Unavailable for 
                                        </div>
                                        <div style={{ color: "rgba(255,255,255,.6)", fontWeight: "bolder", fontSize: 12, marginTop: 2 }}>
                                           <strong>{pendingStockItem?.name}</strong> 
                                        </div>
                                    </div>
                                </div>
                                <div style={dialogBodyStyle}>
                                    <div style={{
                                        background: "#FEF3C7", border: "1px solid #FDE68A",
                                        borderRadius: 10, padding: "14px 16px", marginBottom: 6
                                    }}>
                                        <p style={{ margin: 0, fontSize: 14, color: "#78350F", lineHeight: 1.7 }}>
                                            Since stock is currently unavailable for the selected item, please inform the customer that delivery will require approximately {" "}  <strong>60 to 90 days</strong> from the date of payment.

                                        </p>
                                    </div>
                                    <div style={dialogActionsStyle}>
                                        <button className="dp-btn" style={cancelBtnStyle}
                                            onClick={() => { setStockWarningDialog(false); setPendingStockItem(null) }}>
                                            Cancel
                                        </button>
                                        <button className="dp-btn" style={confirmBtnStyle("#92400E")}
                                            onClick={confirmStockWarning}>
                                            OK, Add Anyway
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {finalizeDialog && (() => {
                    const currentQuote = selectedQuote || quotations.find(q => q.version === version) || null
                    const approvalStatus = currentQuote?.discountApprovalStatus?.status
                    const isPending = approvalStatus === "pending"
                    const isApproved = approvalStatus === "approved"
                    const isRejected = approvalStatus === "rejected"
                    const disc = Number(discountPercent)

                    return (
                        <div style={dialogOverlayStyle}>
                            <div style={dialogBoxStyle} className="dp-modal-enter">
                                  <div style={dialogHeaderStyle()}>
                                <span style={{ fontSize: 22 }}>📋</span>
                                <div>
                                    <div style={{ color: "#fff", fontFamily: '"Playfair Display",serif', fontSize: 17, fontWeight: 600 }}>Finalize Quotation</div>
                                    <div style={{ color: "rgba(255,255,255,.6)", fontSize: 12, marginTop: 2 }}>This action cannot be undone</div>
                                </div>
                            </div>
                                {/* ... header unchanged ... */}
                                <div style={dialogBodyStyle}>
                                    <p style={{ margin: 0, fontSize: 14, color: "#4B5563", lineHeight: 1.6 }}>
                                    Once finalized, you will <strong>not</strong> be able to edit items or quantities. The quotation will be locked and ready to share.
                                </p>
                                    {/* pending banner */}
                                    {isPending && (
                                        <div style={{ background: "#FEF3C7", border: "1px solid #FDE68A", padding: "10px 12px", borderRadius: 8, fontSize: 13, color: "#92400E", marginBottom: 16 }}>
                                            ⏳ A discount approval of <strong>{currentQuote.discountApprovalStatus.discountPercent}%</strong> is currently <strong>pending</strong>. Cannot finalize or send another approval until resolved.
                                        </div>
                                    )}
                                    {isApproved && (
                                        <div style={{ background: "#D1FAE5", border: "1px solid #6EE7B7", padding: "10px 12px", borderRadius: 8, fontSize: 13, color: "#065F46", marginBottom: 16 }}>
                                            ✅ Discount of <strong>{currentQuote.discountApprovalStatus.discountPercent}%</strong> has been <strong>approved</strong>.
                                        </div>
                                    )}
                                    {isRejected && (
                                        <div style={{ background: "#FEE2E2", border: "1px solid #FCA5A5", padding: "10px 12px", borderRadius: 8, fontSize: 13, color: "#991B1B", marginBottom: 16 }}>
                                            ❌ Previous discount request was <strong>rejected</strong>. You may enter a new discount below.
                                        </div>
                                    )}

                                    {/* discount input */}
                                    {!isApproved && (
                                        <div style={{ marginBottom: 16 }}>
                                            <label style={{ display: "block", fontSize: 14, fontWeight: 600, marginBottom: 8, color: "#1B2A4A" }}>
                                                Discount (Max 10%)
                                            </label>
                                            <input
                                                type="number" min="0" max="10"
                                                value={discountPercent}
                                                placeholder="Enter discount %"
                                                disabled={isPending}
                                                onChange={(e) => {
                                                    let value = e.target.value
                                                    if (value > 10) value = 10
                                                    setDiscountPercent(value)
                                                }}
                                                style={{
                                                    width: "100%", padding: "10px 12px", borderRadius: 8,
                                                    border: "1px solid #D1D5DB", outline: "none", fontSize: 14,
                                                    background: isPending ? "#F3F4F6" : "#fff",
                                                    cursor: isPending ? "not-allowed" : "text"
                                                }}
                                            />
                                        </div>
                                    )}

                                    {disc > 5 && !isPending && (
                                        <div style={{ background: "#FFF7ED", border: "1px solid #FDBA74", padding: "10px 12px", borderRadius: 8, fontSize: 13, color: "#9A3412", marginBottom: 16 }}>
                                            Discount above 5% requires approval from your AGM / DGM.
                                        </div>
                                    )}

                                    <div style={dialogActionsStyle}>
                                        <button className="dp-btn" style={cancelBtnStyle} onClick={() => setFinalizeDialog(false)}>
                                            Cancel
                                        </button>
                                        {isPending ? (
                                            <button className="dp-btn" style={{ ...confirmBtnStyle("#9CA3AF"), cursor: "not-allowed", opacity: 0.6 }} disabled>
                                                ⏳ Approval Pending
                                            </button>
                                        ) : disc <= 5 ? (
                                            <button className="dp-btn" style={confirmBtnStyle("#1B2A4A")} onClick={confirmFinalize}>
                                                ✓ Finalize
                                            </button>
                                        ) : isApproved ? (
                                            <button className="dp-btn" style={confirmBtnStyle("#065F46")} onClick={confirmFinalize}>
                                                ✓ Finalize (Approved)
                                            </button>
                                        ) : (
                                            <button className="dp-btn" style={confirmBtnStyle("#D97706")} onClick={() => sendDiscountApproval(discountPercent)}>
                                                Send Approval
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })()}
            </div>
        )
    }
    return (
        <div style={{ minHeight: '100vh', background: '#F0F2F8', fontFamily: '"DM Sans",sans-serif' }}>

            {/* Top Bar */}
            <div style={{ background: '#1B2A4A', padding: '0 32px', display: 'flex', alignItems: 'center', height: 62, boxShadow: '0 2px 12px rgba(0,0,0,.25)' }}>
                <span style={{ color: '#fff', fontFamily: '"Playfair Display",serif', fontSize: 22, fontWeight: 700, letterSpacing: '-.5px', flex: 1 }}>
                    Furniture <span style={{ color: '#F59E0B' }}>One</span>
                </span>
                {
                     isAGMDGM && (
                        <button className="dp-btn" onClick={() => navigateToApprovalPage()}
                            style={{ background: '#12e145ff', color: '#fff', borderRadius: 10, padding: '9px 20px', fontWeight: 700, fontSize: 14, display: 'flex', alignItems: 'center', gap: 8, marginRight: 10 }}>
                            Approvals
                        </button>
                     )}
                <button className="dp-btn" onClick={openNew}
                    style={{ background: '#F59E0B', color: '#fff', borderRadius: 10, padding: '9px 20px', fontWeight: 700, fontSize: 14, display: 'flex', alignItems: 'center', gap: 8 }}>
                    + New Quotation
                </button>
            </div>

            {/* Tabs */}
            <div style={{ background: '#fff', padding: '0 32px', borderBottom: '1px solid #E5E7EB', display: 'flex', gap: 4 }}>
                {[['quotations', '📋 Quotations'], ['items', '📦 Items Catalog']].map(([key, label]) => (
                    <button key={key} className="dp-tab dp-btn"
                        onClick={() => setActiveTab(key)}
                        style={{
                            padding: '14px 18px', fontWeight: activeTab === key ? 700 : 500, fontSize: 14, background: 'transparent',
                            color: activeTab === key ? '#1B2A4A' : '#6B7280',
                            borderBottom: activeTab === key ? '2.5px solid #1B2A4A' : '2.5px solid transparent',
                            borderRadius: 0, marginBottom: -1
                        }}>
                        {label}
                    </button>
                ))}
            </div>

            <div style={{ padding: '28px 32px', maxWidth: 1400, margin: '0 auto', boxSizing: 'border-box' }}>

                {/* ── QUOTATIONS TAB ── */}
                {activeTab === 'quotations' && (
                    <div>
                        <div style={{ background: '#fff', borderRadius: 14, boxShadow: '0 1px 6px rgba(0,0,0,.07)', overflow: 'hidden' }}>

                            <div style={{ padding: '18px 22px', borderBottom: '1px solid #F1F3F9', display: 'flex', alignItems: 'center', gap: 14 }}>
                                <span style={{ fontWeight: 700, fontSize: 16, color: '#1B2A4A', flex: 1, fontFamily: '"Playfair Display",serif' }}>
                                    All Quotations
                                </span>
                            </div>

                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ background: '#F8F9FD' }}>
                                        {['Sl', 'Version', 'Name', 'Email', 'Mobile', 'Items', 'Total', 'Date', 'Status', 'Actions'].map(h => (
                                            <th key={h} style={{
                                                padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700,
                                                color: '#6B7280', letterSpacing: '.6px', textTransform: 'uppercase', whiteSpace: 'nowrap'
                                            }}>
                                                {h}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredQuotes.map((q, index) => {
                                        // Total = rate × qty only — no tax, no discount
                                        const grand = getTotal(q.items)
                                        const isDeleted = q?.deleted
                                        return (
                                            <tr
                                                key={q.version}
                                                className="dp-item-row"
                                                style={{
                                                    borderTop: '1px solid #F1F3F9',
                                                    background: isDeleted ? '#F9FAFB' : '#fff',
                                                    opacity: isDeleted ? 0.6 : 1
                                                }}
                                            >
                                                <td style={{ padding: '14px 16px', fontWeight: 600 }}>
                                                    {index + 1}
                                                </td>

                                                <td style={{ padding: '14px 16px' }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                        <span
                                                            onClick={() => { if (q?.s3Url) { window.open(q.s3Url, "_blank") } }}
                                                            style={{
                                                                fontFamily: 'monospace', fontWeight: 700, fontSize: 13, color: '#1B2A4A',
                                                                background: '#EEF2FF', padding: '3px 10px', borderRadius: 6,
                                                                textDecoration: 'underline', cursor: 'pointer'
                                                            }}
                                                        >
                                                            {q?.version}
                                                        </span>
                                                        {isDeleted && (
                                                            <span style={{ fontSize: 10, background: '#fee2e2', color: '#991b1b', padding: '2px 6px', borderRadius: 4, fontWeight: 600 }}>
                                                                DELETED
                                                            </span>
                                                        )}
                                                        {!q?.finalized && (
                                                            <button
                                                                className="dp-btn"
                                                                onClick={() => openEdit(q)}
                                                                disabled={isDeleted}
                                                                style={{ color: '#050404ff', borderRadius: 6, padding: '3px 8px', fontSize: 11, fontWeight: 600, cursor: isDeleted ? 'not-allowed' : 'pointer' }}
                                                            >
                                                                ✏️
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                                <td style={{ padding: '14px 16px', minWidth: 160 }}>
                                                    <div style={{ fontWeight: 600, fontSize: 14, color: '#1a1a1a' }}>
                                                        {q.customerId?.name || '-'}
                                                    </div>
                                                </td>
                                                <td style={{ padding: '14px 16px', minWidth: 220 }}>
                                                    <div style={{ fontSize: 13, color: '#4B5563' }}>
                                                        {q.customerId?.email || '-'}
                                                    </div>
                                                </td>
                                                <td style={{ padding: '10px 8px', maxWidth: 150 }}>
                                                    <div style={{ fontSize: 13, color: '#4B5563' }}>
                                                        {q.customerId?.contact_no || '-'}
                                                    </div>
                                                </td>
                                                <td style={{ padding: '8px 8px', fontSize: 13, color: '#4B5563', fontWeight: 600, textAlign: 'center' }}>
                                                    {q.items.length}
                                                </td>
                                                <td style={{ padding: '14px 16px' }}>
                                                    <div style={{ fontWeight: 700, fontSize: 15, color: '#1B2A4A' }}>
                                                        {fmt(Math.round(grand))}
                                                    </div>
                                                </td>
                                                <td style={{ padding: '14px 16px', fontSize: 12, color: '#9CA3AF' }}>
                                                    {q?.createdAt ? moment(q?.createdAt).format("DD-MM-YYYY hh:mm A") : "-"}
                                                </td>
                                                <td style={{ padding: '14px 16px' }}>
                                                    <Badge status={q?.status} />
                                                </td>
                                                <td style={{ padding: '14px 16px' }}>
                                                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                                        {
                                                            q?.s3Url && (
                                                                <button className="dp-btn" onClick={() => openEmailDialog(q)} disabled={isDeleted}
                                                                    style={{ background: '#DBEAFE', color: '#1E40AF', borderRadius: 7, padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: isDeleted ? 'not-allowed' : 'pointer' }}>
                                                                    📧 Email
                                                                </button>
                                                            )
                                                        }
                                                        {
                                                            q?.s3Url && (
                                                                <button className="dp-btn" onClick={() => openWhatsAppDialog(q)} disabled={isDeleted}
                                                                    style={{ background: '#D1FAE5', color: '#065F46', borderRadius: 7, padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: isDeleted ? 'not-allowed' : 'pointer' }}>
                                                                    💬 WhatsApp
                                                                </button>
                                                            )
                                                        }
                                                        {
                                                             q?.finalized && q?.status !== "paid" && !q?.invoiceId &&  (
                                                                <button className="dp-btn" onClick={() => openPaidDialog(q)} disabled={isDeleted}
                                                                    style={{ background: '#EEF2FF', color: '#1B2A4A', borderRadius: 7, padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: isDeleted ? 'not-allowed' : 'pointer' }}>
                                                                    ✓ Mark Paid
                                                                </button>
                                                            )
                                                        }
                                                       
                                                        {
                                                            !q.s3Url &&  (
                                                                <button className="dp-btn" onClick={() => handleGeneratePDF(q)}
                                                                    style={{ background: '#FEF3C7', color: '#92400E', borderRadius: 7, padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: isDeleted ? 'not-allowed' : 'pointer' }}>
                                                                    📄 Gen Invoice
                                                                </button>
                                                            )
                                                        }
                                                        
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}

                                    {filteredQuotes.length === 0 && (
                                        <tr>
                                            <td colSpan={10} style={{ padding: 48, textAlign: 'center', color: '#9CA3AF', fontSize: 14 }}>
                                                No quotations found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {/* ── ITEMS TAB ── */}
                {activeTab === 'items' && (
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20, gap: 14 }}>
                            <div style={{ flex: 1 }}>
                                <h2 style={{ margin: 0, fontFamily: '"Playfair Display",serif', color: '#1B2A4A', fontSize: 22 }}>Items Catalog</h2>
                                <p style={{ margin: '4px 0 0', color: '#9CA3AF', fontSize: 13 }}>{ITEMS_CATALOG.length} items available</p>
                            </div>
                            <SearchBar value={itemSearch} onChange={setItemSearch} placeholder="Search by name, category, SKU…" style={{ width: 320 }} />
                        </div>

                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 20 }}>
                            {['All', ...Array.from(new Set(ITEMS_CATALOG.map(i => i.group_name)))].map(g => (
                                <button key={g} className="dp-btn"
                                    onClick={() => setItemSearch(g === 'All' ? '' : g)}
                                    style={{
                                        padding: '6px 14px', borderRadius: 99, fontSize: 12, fontWeight: 600,
                                        background: (g === 'All' && !itemSearch) || itemSearch === g ? '#1B2A4A' : '#fff',
                                        color: (g === 'All' && !itemSearch) || itemSearch === g ? '#fff' : '#4B5563',
                                        border: (g === 'All' && !itemSearch) || itemSearch === g ? 'none' : '1.5px solid #E5E7EB'
                                    }}>
                                    {g}
                                </button>
                            ))}
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 20 }}>
                            {paginatedItems.map(item => (
                                <div key={item.item_id} className="dp-card" style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 1px 8px rgba(0,0,0,.07)' }}>
                                    <img onClick={() => navigateToItemDetail(item)} src={item.img} alt={item.name} style={{ width: '100%', height: 170, objectFit: 'cover', display: 'block' ,cursor: "pointer", transition: "transform 0.2s ease"}} />
                                    <div style={{ padding: '14px 16px 16px' }}>
                                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8, marginBottom: 6 }}>
                                            <div style={{ fontWeight: 700, fontSize: 14, color: '#1a1a1a', lineHeight: 1.3 }}>{item.name} </div>
                                            <span style={{ fontSize: 10, fontWeight: 600, color: '#6B7280', background: '#F1F3F9', padding: '2px 8px', borderRadius: 6, whiteSpace: 'nowrap', flexShrink: 0 }}>{item.group_name}</span>
                                        </div>
                                        <p style={{ margin: '0 0 12px', fontSize: 12, color: '#9CA3AF', lineHeight: 1.5 }}>{item.description}</p>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <div>
                                                {item.label_rate > item.rate && (
                                                    <span
                                                        style={{fontWeight: 400,fontSize: 17, color: '#dc0909ff', textDecoration: 'line-through', marginRight: 6}} >{fmt(item.label_rate)}
                                                    </span> )}
                                                <span
                                                    style={{  fontWeight: 800,fontSize: 17, color: '#1B2A4A' }} >
                                                    {fmt(item.rate)}
                                                </span>
                                                {item.label_rate > item.rate && (
                                                    <span
                                                        style={{
                                                            marginLeft: 6,
                                                            fontSize: 11,
                                                            color: '#10B981',
                                                            fontWeight: 600
                                                        }}
                                                    >
                                                        ({Math.round(((item.label_rate - item.rate) / item.label_rate) * 100)}% OFF)
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 10 }}>
                                            <div style={{
                                                display: 'inline-flex', alignItems: 'center', gap: 6, background: item.stock > 10 ? '#ECFDF5' : item.stock > 0 ? '#FEF3C7' : '#FEE2E2', color: item.stock > 10 ? '#065F46' : item.stock > 0 ? '#92400E' : '#991B1B', padding: '5px 10px',
                                                borderRadius: 999, fontSize: 11, fontWeight: 700, width: 'fit-content'
                                            }}
                                            >  <span style={{ width: 7, height: 7, borderRadius: '50%', background: item.stock > 10 ? '#10B981' : item.stock > 0 ? '#F59E0B' : '#EF4444' }} />{item.stock > 0 ? `${item.stock} In Stock` : 'Out of Stock'}
                                            </div>
                                        </div>
                                        <div style={{ marginTop: 12 }}>
                                            <button className="dp-btn" onClick={openNew}
                                                style={{ width: '100%', background: '#1B2A4A', color: '#fff', borderRadius: 9, padding: '9px', fontSize: 13, fontWeight: 600 }}>
                                                + Create Quote
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {filteredItems.length === 0 && (
                                <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: 60, color: '#9CA3AF' }}>
                                    <div style={{ fontSize: 40, marginBottom: 12 }}>🔍</div>
                                    <p style={{ margin: 0, fontSize: 15 }}>No items match your search</p>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

            {showRelogin && (
                <Modal  onClose={() => { setShowRelogin(false); window.location.reload()}}>
                    <div style={{ textAlign: 'center', minWidth: 360 }}>
                        <div style={{ fontSize: 40, marginBottom: 10 }}>🔐</div>
                        <h2 style={{ margin: 0, fontSize: 20, color: '#1B2A4A', fontFamily: '"Playfair Display",serif' }}>
                            Session Expired
                        </h2>
                        <p style={{ color: '#6B7280', fontSize: 13, margin: '8px 0 20px' }}>
                            Zoho POS session expired. Please re-login to continue.
                        </p>
                        <button className="dp-btn" onClick={handleRelogin}
                            style={{ background: '#1B2A4A', color: '#fff', borderRadius: 10, padding: '10px 20px', fontWeight: 600 }}>
                            Re-Login
                        </button>
                    </div>
                </Modal>
            )}

            {/* ── Email Dialog ── */}
            {emailDialog && (
                <div style={dialogOverlayStyle}>
                    <div style={dialogBoxStyle} className="dp-modal-enter">
                        <div style={dialogHeaderStyle("#1e3a8a")}>
                            <span style={{ fontSize: 22 }}>📧</span>
                            <div>
                                <div style={{ color: "#fff", fontFamily: '"Playfair Display",serif', fontSize: 17, fontWeight: 600 }}>Send via Email</div>
                                <div style={{ color: "rgba(255,255,255,.6)", fontSize: 12, marginTop: 2 }}>Quotation {selectedQuote?.version}</div>
                            </div>
                        </div>
                        <div style={dialogBodyStyle}>
                            <label style={{ fontSize: 11, fontWeight: 700, color: "#6B7280", letterSpacing: ".5px", textTransform: "uppercase" }}>Recipient Email</label>
                            <input className="dp-input" style={dialogInputStyle} value={emailInput}
                                onChange={e => setEmailInput(e.target.value)} placeholder="customer@email.com" type="email" />
                            <div style={dialogActionsStyle}>
                                <button className="dp-btn" style={cancelBtnStyle} onClick={() => setEmailDialog(false)}>Cancel</button>
                                <button className="dp-btn" style={{
                                    ...confirmBtnStyle("#065f46"),
                                    cursor: emailInput.length ? "pointer" : "not-allowed",
                                    opacity: emailInput.length ? 1 : 0.6
                                }} onClick={confirmEmail} disabled={!emailInput.length}>📧 Send Email</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── WhatsApp Dialog ── */}
            {whatsAppDialog && (
                <div style={dialogOverlayStyle}>
                    <div style={dialogBoxStyle} className="dp-modal-enter">
                        <div style={dialogHeaderStyle("#065f46")}>
                            <span style={{ fontSize: 22 }}>💬</span>
                            <div>
                                <div style={{ color: "#fff", fontFamily: '"Playfair Display",serif', fontSize: 17, fontWeight: 600 }}>Send via WhatsApp</div>
                                <div style={{ color: "rgba(255,255,255,.6)", fontSize: 12, marginTop: 2 }}>Quotation {selectedQuote?.version}</div>
                            </div>
                        </div>
                        <div style={dialogBodyStyle}>
                            <label style={{ fontSize: 11, fontWeight: 700, color: "#6B7280", letterSpacing: ".5px", textTransform: "uppercase" }}>Mobile Number</label>
                            <input className="dp-input" style={dialogInputStyle} value={whatsInput}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    if (value.length <= 10) setWhatsInput(value);
                                }}
                                placeholder="Enter 10 digit whatsapp number" type="tel" maxLength={10} />
                            <div style={dialogActionsStyle}>
                                <button className="dp-btn" style={cancelBtnStyle} onClick={() => setWhatsAppDialog(false)}>Cancel</button>
                                <button className="dp-btn" style={{
                                    ...confirmBtnStyle("#065f46"),
                                    cursor: whatsInput.length === 10 ? "pointer" : "not-allowed",
                                    opacity: whatsInput.length === 10 ? 1 : 0.6
                                }} onClick={confirmWhatsApp} disabled={whatsInput.length !== 10}>💬 Send</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Mark Paid Dialog ── */}
            {paidDialog && (
    <div style={dialogOverlayStyle}>
        <div style={dialogBoxStyle} className="dp-modal-enter">
            <div style={dialogHeaderStyle("#064e3b")}>
                <span style={{ fontSize: 22 }}>✅</span>
                <div>
                    <div style={{ color: "#fff", fontFamily: '"Playfair Display",serif', fontSize: 17, fontWeight: 600 }}>Mark as Paid</div>
                    <div style={{ color: "rgba(255,255,255,.6)", fontSize: 12, marginTop: 2 }}>Quotation {selectedQuote?.version}</div>
                </div>
            </div>
            <div style={dialogBodyStyle}>

                {/* Warning Banner */}
                <div style={{
                    background: "#FEF3C7",
                    border: "1px solid #FDE68A",
                    borderRadius: 10,
                    padding: "12px 14px",
                    marginBottom: 16,
                    display: "flex",
                    gap: 10,
                    alignItems: "flex-start"
                }}>
                    <span style={{ fontSize: 16, flexShrink: 0 }}>⚠️</span>
                    <div>
                        <div style={{ fontSize: 13, fontWeight: 700, color: "#92400E", marginBottom: 3 }}>
                            This action cannot be undone
                        </div>
                        <div style={{ fontSize: 12, color: "#78350F", lineHeight: 1.6 }}>
                            Once marked as paid, the order will be <strong>confirmed</strong> and an invoice will be generated.
                            Please ensure <strong>100% payment has been received</strong> before proceeding.
                        </div>
                    </div>
                </div>

                {/* Remarks */}
                <div style={{ marginBottom: 14 }}>
                    <label style={{ fontSize: 11, fontWeight: 700, color: "#6B7280", letterSpacing: ".5px", textTransform: "uppercase" }}>Remarks</label>
                    <textarea
                        className="dp-input"
                        style={{ ...dialogInputStyle, minHeight: 90, resize: "vertical" }}
                        placeholder="Add payment notes, reference number, etc."
                        value={paidRemarks}
                        onChange={e => setPaidRemarks(e.target.value)}
                    />
                </div>

                {/* File Upload */}
                <div>
                    <label style={{ fontSize: 11, fontWeight: 700, color: "#6B7280", letterSpacing: ".5px", textTransform: "uppercase" }}>Attach Proof (Mandatory)</label>
                    <div style={{ marginTop: 8, border: "1.5px dashed #D1D5DB", borderRadius: 10, padding: "14px 16px", background: "#F9FAFB", textAlign: "center" }}>
                        <input
                            type="file"
                            multiple
                            onChange={handlePaidFileChange}
                            style={{ fontSize: 13, color: "#4B5563", cursor: "pointer" }}
                            disabled={uploadingFiles}
                        />
                        {uploadingFiles && (
                            <div style={{ marginTop: 8, fontSize: 12, color: "#6B7280" }}>
                                ⏳ Uploading...
                            </div>
                        )}
                        {!uploadingFiles && paidS3Links.length > 0 && (
                            <div style={{ marginTop: 8, fontSize: 12, color: "#10B981", fontWeight: 600 }}>
                                ✅ {paidS3Links.length} file{paidS3Links.length > 1 ? "s" : ""} uploaded
                            </div>
                        )}
                    </div>
                </div>

                {/* Actions */}
                <div style={dialogActionsStyle}>
                    <button className="dp-btn" style={cancelBtnStyle} onClick={closePaidDialog}>
                        Cancel
                    </button>
                    <button
                        className="dp-btn"
                        style={{
                            ...confirmBtnStyle("#065f46"),
                            opacity: isDisabled ? 0.5 : 1,
                            cursor: isDisabled ? "not-allowed" : "pointer",
                            background: isDisabled ? "#9CA3AF" : "#065f46"
                        }}
                        onClick={confirmPaid}
                        disabled={isDisabled}
                    >
                        ✓ Mark Paid
                    </button>
                </div>

            </div>
        </div>
    </div>
)}
        </div>
    )
}

// ─── Reusable Modal ───────────────────────────────────────────────────────────
function Modal({ children, onClose }) {
    useEffect(() => {
        const handler = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', handler)
        return () => document.removeEventListener('keydown', handler)
    }, [onClose])

    return (
        <div onClick={onClose}
            style={{ position: 'fixed', inset: 0, background: 'rgba(15,20,40,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, backdropFilter: 'blur(3px)', padding: 20 }}>
            <div className="dp-modal-enter" onClick={e => e.stopPropagation()}
                style={{ background: '#fff', borderRadius: 18, padding: 32, maxHeight: '90vh', overflowY: 'auto', position: 'relative', boxShadow: '0 24px 80px rgba(0,0,0,.28)' }}>
                <button onClick={onClose}
                    style={{ position: 'absolute', top: 14, right: 14, background: '#F1F3F9', border: 'none', borderRadius: 99, width: 32, height: 32, cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#4B5563' }}>×</button>
                {children}
            </div>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(FurnitureOne)